// extracted by mini-css-extract-plugin
export default {"EditableKeyGiverDropsView":"EditableKeyGiverDropsView_EditableKeyGiverDropsView__abyaJ"};